var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignCenter = function SvgAlignCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.273 17.4a.6.6 0 1 1 0 1.2H4.728a.6.6 0 0 1 0-1.2zm-2.078-6a.6.6 0 0 1 0 1.2H6.805a.6.6 0 0 1 0-1.2zm4.156-6a.6.6 0 0 1 0 1.199H2.649a.6.6 0 1 1 0-1.2z"
  })));
};
export default SvgAlignCenter;